// Une réponse détaillée est soit une page complète (source d'artifact, qui porte déjà
// ses styles), soit un simple fragment collé depuis un éditeur. Sans enveloppe, le
// fragment s'affiche avec les défauts du navigateur : Times New Roman, aucune couleur.
const isFullDocument = (html: string) => /^\s*(<!doctype\s+html|<html[\s>])/i.test(html);

const BASE_STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap");

:root {
  color-scheme: light;
  --y-fg: oklch(0.145 0 0);
  --y-muted-fg: oklch(0.556 0 0);
  --y-muted: oklch(0.97 0 0);
  --y-border: oklch(0.922 0 0);
  --y-primary: oklch(0.62 0.19 260);
}

* { box-sizing: border-box; }
html { -webkit-text-size-adjust: 100%; }

body {
  margin: 0;
  padding: 24px;
  font-family: "Plus Jakarta Sans", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif;
  font-size: 15px;
  line-height: 1.65;
  color: var(--y-fg);
  background: #fff;
}

body > * { max-width: 76ch; margin-left: auto; margin-right: auto; }
body > :first-child { margin-top: 0; }

h1, h2, h3, h4 { font-weight: 700; line-height: 1.3; margin: 1.6em 0 0.5em; }
h1 { font-size: 1.55em; }
h2 { font-size: 1.3em; }
h3 { font-size: 1.1em; }

p { margin: 0 0 1em; }
strong, b { font-weight: 700; }
em, i { font-style: italic; }

a { color: var(--y-primary); text-decoration: underline; text-underline-offset: 2px; }

ul, ol { margin: 0 0 1em; padding-left: 1.4em; }
li { margin-bottom: 0.5em; }
li > div > p:last-child { margin-bottom: 0; }

code, pre { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 0.9em; }
code { background: var(--y-muted); padding: 1px 5px; border-radius: 4px; }
pre { background: var(--y-muted); padding: 12px 14px; border-radius: 8px; overflow-x: auto; }
pre code { background: none; padding: 0; }

table { border-collapse: collapse; width: 100%; margin: 1em 0; font-size: 0.95em; }
th, td { border: 1px solid var(--y-border); padding: 8px 12px; text-align: left; vertical-align: top; }
th { background: var(--y-muted); font-weight: 600; }
caption { caption-side: top; text-align: left; font-size: 0.8em; color: var(--y-muted-fg); padding-bottom: 6px; }

blockquote { margin: 1em 0; padding: 8px 16px; border-left: 3px solid var(--y-primary); color: var(--y-muted-fg); }
hr { border: 0; border-top: 1px solid var(--y-border); margin: 2em 0; }
img { max-width: 100%; height: auto; border-radius: 8px; }
`;

export const buildRichAnswerDocument = (html: string): string => {
  if (isFullDocument(html)) return html;

  // Le base href fait résoudre les chemins d'assets relatifs sur l'origine de l'app,
  // l'iframe étant en origine opaque et donc sans URL de référence.
  const baseHref = typeof window === "undefined" ? "/" : `${window.location.origin}/`;

  return `<!doctype html>
<html lang="fr">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<base href="${baseHref}">
<style>${BASE_STYLES}</style>
</head>
<body>${html}</body>
</html>`;
};
